<template>
    <div class="row justify-between full-width no-wrap text-datestamp-item">
      <div class="col">
        <div class="row justify-left no-wrap">
          <q-toggle
            v-model="tmpModelData.Positive"
            checked-icon="add"
            color="navy"
            label=""
            size="xs"
            unchecked-icon="remove"
          />
          <div class="q-py-xs text-bold"></div>
          <q-radio size="xs" v-model="tmpModelData.FilterType" checked-icon="task_alt" unchecked-icon="panorama_fish_eye" 
            :val="0" :label="$t('on_stage')" />
          <q-radio size="xs" v-model="tmpModelData.FilterType" checked-icon="task_alt" unchecked-icon="panorama_fish_eye" 
            :val="1" :label="$t('set_to_stage')" />
        </div>
        <div v-if="tmpModelData.FilterType" class="row justify-left no-wrap">
          <div v-if="tmpModelData.FilterType" class="q-py-xs">c:&nbsp;</div>
          <div v-if="tmpModelData.FilterType" class="q-py-xs">{{ getStartDate }}</div>
          <div class="q-py-xs">&nbsp;&nbsp;{{ $t('by') }}:&nbsp;</div>
          <div class="q-py-xs">{{ getEndDate }}</div>
          <mosta-checkbox
            v-model="tmpModelData.EndDateIsToday"
            :label="$t('today_calendar')"
            style="margin-left: 6px; margin-top: 4px;"
          />
        </div>
      </div>
      <q-btn
        class="q-mx-none q-mt-none unset-items-center del-btn-datestamp"
        flat
        dense
        :aria-label="$t('delete_filter')"
        icon="close"
        size="sm"
        tabindex="-1"
        color="accent"
        @click="deleteItem"
      >
        <q-tooltip :delay="300" anchor="top middle" self="center middle">
          {{ $t('remove') }}
        </q-tooltip>
      </q-btn>
    </div>
  </template>
  
  <script lang="ts">
  import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
  import { SelectionProjectStageFilterSend } from '@/models/interfaces/entity-settings/filters/filters';
  import { date } from 'quasar'
import { reactive, ref } from 'vue';
  import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';
  
  @Component({
    name: 'ProjectStageItemElement',
    components: { MostaCheckbox },
  })
  export default class ProjectStageItemElement extends Vue {
      @Emit("itemDeleted") emitDeleteItem(arg: number) { return arg; }
  
      @Prop({ default: {} as SelectionProjectStageFilterSend })
      modelValue!: SelectionProjectStageFilterSend

      @Emit("update:modelValue") emitModelValue(arg: SelectionProjectStageFilterSend) { return arg; }
      tmpModelData = ref(this.modelValue)
  
      @Prop({ default: undefined })
      parentId!: number | undefined
      @Prop({ default: undefined })
      parentIdx!: string | undefined
      @Prop({ default: '' })
      parentName!: string
      @Prop({ default: -1 })
      inputIndex!: number
  
      @Watch('modelValue', { deep: true })
      created() {
          // @ts-ignore
          this.tmpModelData = this.modelValue
      }

      @Watch('tmpModelData', { deep: true })
      modelUpdated(arg: SelectionProjectStageFilterSend) {
        console.log('model data updated')
        // @ts-ignore
        this.emitModelValue(this.tmpModelData)
      }
  
      get getStartDate(): string {
        // @ts-ignore
        const sd = this.tmpModelData.StartDate || new Date()
        return date.formatDate(sd, 'DD.MM.YYYY')
      }

      get getEndDate(): string {
        // @ts-ignore
        const ed = this.tmpModelData.EndDate || new Date()
        return date.formatDate(ed, 'DD.MM.YYYY')
      }
  
      @Watch('inputItems', { deep: true })
      updateItems() {
          // remember state
          // @ts-ignore
      }

      deleteItem() {
        this.emitDeleteItem(this.inputIndex)
      }
  }
  </script>
  
  <style lang="scss">
  .del-btn-datestamp {
    margin-top: 2px !important;
  }
   
  .text-datestamp-item {
    &--child {
      margin-left: 26px !important;
    }
  }
  </style>